import {
  SAVE_BROKER_SETTINGS,
  RECEIVE_BROKER_SAVE_SETTINGS,
  ERROR_BROKER_SAVE_SETTINGS,

  REQUEST_BROKER_SETTINGS,
  RECEIVE_BROKER_SETTINGS,
  ERROR_BROKER_SETTINGS,

  SAVE_BROKER_COMPANIES,
  RECEIVE_BROKER_SAVE_COMPANIES,
  ERROR_BROKER_SAVE_COMPANIES,

  SAVE_BROKER_CORRESPONDENT,
  RECEIVE_BROKER_SAVE_CORRESPONDENT,
  ERROR_BROKER_SAVE_CORRESPONDENT,


} from 'typeConstants';
import { brokerMaintenanceSettings as initialState } from '../initialState.tsx';

const brokerMaintenanceSettings = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_BROKER_SETTINGS:
      return {
        ...state,
        isSubmittingSettings: true
      };

    case RECEIVE_BROKER_SAVE_SETTINGS:
      return {
        ...state,
        isSubmittingSettings: false,
        success: action.payload.success,

      };
    case ERROR_BROKER_SAVE_SETTINGS:
      return {
        ...state,
        isSubmittingSettings: false
      };
    case SAVE_BROKER_COMPANIES:
      return {
        ...state,
        isSubmittingSettings: true
      };

    case RECEIVE_BROKER_SAVE_COMPANIES:
      return {
        ...state,
        isSubmittingSettings: false,
        success: action.payload.success,

      };
    case ERROR_BROKER_SAVE_COMPANIES:
      return {
        ...state,
        isSubmittingSettings: false
      };
    case SAVE_BROKER_CORRESPONDENT:
      return {
        ...state,
        isSubmittingSettings: true
      };

    case RECEIVE_BROKER_SAVE_CORRESPONDENT:
      return {
        ...state,
        isSubmittingSettings: false,
        success: action.payload.success,

      };
    case ERROR_BROKER_SAVE_CORRESPONDENT:
      return {
        ...state,
        isSubmittingSettings: false
      };
    case REQUEST_BROKER_SETTINGS:
      return {
        ...state,
        isFetchingSettings: true
      };
    case RECEIVE_BROKER_SETTINGS:
      return {
        ...state,
        brokerSettings: action.payload,
        isFetchingSettings: false
      };
    case ERROR_BROKER_SETTINGS:
      return {
        ...state,
        isFetchingSettings: false
      };

    default:
      return state;
  }
};

export default brokerMaintenanceSettings;
